import _ from 'lodash'
import Record from '../records/Record'

class AlertsHistoryController {
  constructor($location, alertService, $log, $q, $analytics) {
    this.$location = $location
    this.alertService = alertService
    this.$log = $log
    this.$q = $q
    this.$analytics = $analytics
    this.alerts = []
    this.alertData = {}
    this.alertUserId = this.$location.search().userId
    this.alertHmac = this.$location.search().hmac
    this.clickedAlertId = undefined
    this.queryRunning = false

    this.initAlertDate()
    this.gatherAlerts()
  }

  gatherAlerts() {
    this.queryRunning = true
    this._cleanSlate()
    this.alertService.query(
      {userId: this.alertUserId},
      this._queryAlerts.bind(this),
      this._handleError.bind(this)
    )
  }

  _queryAlerts(alerts) {
    this.alerts = alerts
    this.$q.all(
      _.map(alerts, this._queryAlertData.bind(this))
    ).then(
      this._displayQueriedAlerts.bind(this),
      this._handleError.bind(this)
     )
  }

  _displayQueriedAlerts() {
    this._filterAlerts()
    this._sortAlerts()
    this.activeAlert = this.alerts[0]
    if(this.activeAlert) {
      this.selectedAlertId = this.activeAlert.alertId
    }
    this.queryRunning = false
  }

  // don't show alerts if they don't have results
  _filterAlerts() {
    this.alerts = _.filter(this.alerts, a => {
      return a.totalMatchingRecords > 0
    })
  }

  // to display results in order for the vertical nav
  _sortAlerts() {
    this.alerts = _.sortBy(this.alerts, 'totalMatchingRecords').reverse()
  }

  _queryAlertData(element) {
    this.$analytics.eventTrack(
        'Alert History Queried',
        {'Alert Date': this.alertDate.toString()}
    )

    // TODO: Update this to use records resource: Record.get(element.alertId)
    return this.alertService.queryAlert(element.alertId, alertData => {
        alertData.records = this._convertRecords(alertData.records)
        this.alertData[element.alertId] = alertData
        element.totalMatchingRecords = alertData.totalMatchingRecords
      },
      fail => this._handleError(),
      this.alertDate,
      this.alertUserId,
      this.alertHmac)
  }

  _convertRecords(records) {
    return _(records)
      .map(r => Record.fromJson(r))
      .value()
  }

  get sumMatchingRecords() {
    return _.chain(this.alerts)
      .map(a => a.totalMatchingRecords)
      .sum()
      .value()
  }

  get numberOfAlerts() {
    return this.alerts.length
  }

  get activeAlertFilters() {
    if(this.activeAlert) {
     return JSON.stringify(this.activeAlert.filter).replace(/\{|\"|\}/g, ' ')
    }
  }

  set selectedAlertId(id) {
    this.clickedAlertId = id
  }

  get selectedAlertId() {
    return this.clickedAlertId
  }

  get urlDate() {
    const requestDate = this.$location.search().alertDate
    return requestDate
      ? new Date(requestDate)
      : new Date()
  }

  initAlertDate() {
    this.alertDate = this.urlDate
  }

  _cleanSlate() {
    this.selectedAlertId = undefined
    this.errorMesage = ''
  }

  _handleError() {
    this.errorMessage = `We could not retrieve your alerts at this time.
      Please try again later`
  }

}

AlertsHistoryController.$inject = [
  '$location',
  'AlertService',
  '$log',
  '$q',
  '$analytics'
]

export default AlertsHistoryController
